import React from "react";

export default function CheckBox({ onChange, isChecked, value }) {
  return <input onChange={onChange} type="checkbox" checked={isChecked} value={value} />;
}
